import { render, staticRenderFns } from "./ConfirmEmailSending.vue?vue&type=template&id=b679c8de"
import script from "./ConfirmEmailSending.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailSending.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmailSending.vue?vue&type=style&index=0&id=b679c8de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports